<template>
    <div class="timer">
        <div class="container-fluid mx-3 md:mx-10 my-8">
            <div class="flex flex-wrap items-stretch -mx-4 mb-6" v-if="hasTasks">
                <div class="w-full px-4">
                    <h2 class="text-xl mb-4 mt-6 flex items-center"><span class="rounded-full h-6 w-1 bg-orange-500 inline-block mr-2"></span> Tvoje úlohy</h2>
                </div>
                <div v-for="project in latestActivity.tasks" class="w-1/4 px-4 my-2 h-auto">
                    <div class="h-full bg-white shadow-md">
                        <div class="px-4 py-2 flex flex-wrap items-center">
                            <div class="w-1/8">
                                <span class="flex items-center">
                                    <span class="w-3 h-3 block rounded-full mr-2" :class="`bg-${project.project.status.color}-400`"></span>
                                    <router-link class="text-black hover:text-orange-500" :to="{name: 'projects.detail', params: {projectId: project.project.id}}">
                                        {{ project.project.name }}
                                        <span class="text-primary"><md-icon class="text-md">link</md-icon></span>
                                    </router-link>
                                </span>
                            </div>
                            <div class="ml-auto w-2/8">
                                <div class="flex">
                                    <avatar v-for="(user, index) in project.project.users.slice(0, 3)"
                                            :key="`tasku${user.id}`"
                                            :class="index !== 0 ? '-ml-2' : ''" :member="user" />
                                </div>
                            </div>
                        </div>
                        <div class="w-full py-2 border-t border-gray-100">
                            <div v-for="group in project.groups" class="mt-3">
                                <span class="text-gray-500 px-4">{{ group.name }}</span>
                                <div>
                                    <div v-for="(task, index) in group.tasks" class="flex items-center mx-2 border-b border-gray-100" :class=" index !== group.tasks.length-1 ? `border-b border-gray-200` : ''">
                                            <span class="transition">
                                                <md-button class="md-dense md-accent md-icon-button" @click="() => runJob(project.project, task)">
                                                    <md-icon>play_arrow</md-icon>
                                                </md-button>
                                            </span>
                                        <span>{{ task.content }}</span>
                                        <div class="ml-auto">
                                            <md-checkbox v-model="task.done" @change="() => checkItem(project, group, task)"></md-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <h1 class="text-xl mb-4 mt-6 flex items-center"><span class="rounded-full h-6 w-1 bg-orange-500 inline-block mr-2"></span> Posledná aktivita</h1>
            <p v-if="!hasLatestActivity" class="text-gray-500 text-sm my-8">Ajajaj, zdá sa že za posledné dni ste nič neurobili. Skúste to zmeniť tým že sa opýtate na prácu u niekoho z manážerov.</p>
            <transition-group name="fade" mode="out-in">
                
                <div v-for="(latestAct, key) in groupActivities" :key="'last'+key">
                    <div class="flex items-center pr-4 mt-6 mb-4">
                        <h6 class="font-bold text-lg ml-4">{{ nowKey === key ? 'Dnes, ' : '' }}{{ formatKey(key) }}</h6>
                        <span class="font-bold text-lg ml-auto flex items-center justify-center">{{ getTotalOfGroup(latestAct) }} | {{calcCoins(getTotalOfGroup(latestAct, true))}} <img class="ml-1 w-5 inline-block" src="../assets/sixcoin_flat_s.png" title="sixcoinov" alt="sixcoinov"></span>
                    </div>
                    <transition-group name="fade" mode="out-in">
                        <div v-for="latest in latestAct" :key="'pix'+latest.id" class="w-full rounded-full shadow-md bg-white flex items-center my-3">
                            <div class="py-2 px-3 md:py-3 md:px-6 flex items-center bg-gray-200 rounded-full">
                                <md-button @click="() => runActivity(latest)" class="md-dense md-accent md-icon-button -ml-2 mr-2">
                                    <md-icon>play_arrow</md-icon>
                                </md-button>
                                <span class="py-1 px-2 font-light text-xs w-32 md:w-20 text-center rounded-full text-white md:mr-4"
                                      :class="latest.managers.length > 0 ? 'bg-'+latest.managers[0].color : 'bg-gray-400'">
                                    <span v-if="!$isMobile">{{ latest.managers.length > 0 ? shortifyName(latest.managers[0].name) : 'Nepridelené' }}</span>
                                    <span v-if="$isMobile">{{ latest.project.name }}</span>
                                </span>
                                <span v-if="!$isMobile" class="text-sm font-bold w-48">
                                    <router-link class="text-black hover:text-orange-700 flex items-center" :to="{name: 'projects.detail', params: {projectId: latest.project.id}}">
                                        {{ latest.project.name }}
                                       <span class="text-primary ml-auto"><md-icon class="text-md">link</md-icon></span>
                                    </router-link>
                                </span>
                            </div>
                            <div class="py-2 px-3 md:py-3 md:px-6 flex items-center w-full">
                                <span v-if="!$isMobile" class="md:ml-2 text-sm text-gray-500"
                                      v-html="latest.note"></span>
                                <span class="mr-3 ml-auto uppercase w-3 h-3 rounded-full" :class="latest.fixing ? 'bg-red-500' : ''" title="Oprava"></span>
                                <span v-if="typeof latest.tag !== 'undefined'" class="bg-gray-200 px-3 py-1 rounded-full text-xs text-gray-500"><font-awesome class="mr-1" icon="tag"></font-awesome> {{ latest.tag ? latest.tag.name : 'undefined' }}</span>
                                <span v-if="!$isMobile" class="text-md text-right mr-6 text-gray-400 w-24">{{ getOnlyTime(latest.start_timestamp) }} – {{ getOnlyTime(latest.end_timestamp) }}</span>
                                <span class="text-md font-bold">{{ formatTime(latest.total_time) }}</span>
                                
                            </div>
                        </div>
                    </transition-group>
                </div>
                
            </transition-group>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import {EventBus, capitalize, formatTotal, shortifyName, sortObj} from "../utils";
    import Avatar from "../components/Avatar";
    import _ from 'lodash';
    
    export default {
        name: "Timer",
        components: {Avatar},
        metaInfo() {
            return {
                titleTemplate: chunk => {
                    return (chunk ? chunk + " - Časovač - " : "Časovač - ") + this.$appName;
                },
            }
        },

        mounted() {
            this.$store.dispatch('fetchLatestActivity', {daysBack: 5});
            
            EventBus.$on("runTimer", () => {
                this.$store.dispatch('fetchLatestActivity', {daysBack: 5});
            });
        },
        
        computed: {
            ...mapState({
                user: state => state.account.user,
                latestActivity: state => state.latestActivity.activities,
                running: state => state.timer.running
            }),
            
            nowKey() {
                return moment().format("DD-MM-YYYY");
            },
            
            hasLatestActivity() {
                return Object.keys(this.latestActivity.activity).length > 0;
            },

            hasTasks() {
                return Object.keys(this.latestActivity.tasks).length > 0;
            },
            
            groupActivities() {
               return _.groupBy(this.latestActivity.activity, 'date');
            }
        },
        
        methods: {
            runActivity(activity) {
                this.$store.dispatch('startActivity', {
                    selectedProject: activity.project,
                    note: activity.note,
                    fixing: activity.fixing,
                    tag_id: activity.tag.id
                }).then(() => {
                    this.$store.dispatch('fetchRunningActivity').then(() => {
                        EventBus.$emit("runTimer", activity.project, activity.note);
                    })
                });
                
            },
            runJob(project, task) {
                let tag = 1;
                
                if(this.user.type.id === 2) {
                    tag = 5;
                }else if(this.user.type.id === 3) {
                    tag = 3;
                }
                
                this.$store.dispatch('startActivity', {
                    selectedProject: project,
                    note: task.content,
                    fixing: false,
                    tag_id: tag
                }).then(() => {
                    this.$store.dispatch('fetchRunningActivity').then(() => {
                        EventBus.$emit("runTimer", project, task.content);
                    })
                })
            },
            
            checkItem(project, group, task) {
                // console.log(project, group, task)
                this.$store.dispatch("updateTask", task)
                    .then(() => {
                        this.$store.dispatch("fetchLatestActivity");
                    });
            },
            
            getTotalOfGroup(activities, only_time = false) {
                let total = 0;
                for (let activity of activities) {
                    total += activity.total_time;
                }
                if(only_time)
                    return total;
                else
                    return this.formatTime(total);
            },

            getOnlyTime (date) {
                let time = moment.unix(date).local(false);
                return time.format('H:mm');
            },
            
            shortifyName(name) {
                return shortifyName(name);
            },

            formatTime(time) {
                return formatTotal(time);
            },
            
            formatKey(key) {
                let keyMoment = moment(key, "DD-MM-YYYY");
                
                if(key === this.nowKey) {
                    return keyMoment.format("D. M. YYYY");
                }

                return capitalize(keyMoment.format("dddd, D. M. YYYY"))
            },
            
            calcCoins(seconds) {
                return Math.floor(seconds / 1800);
            }
        },
    };
</script>
